import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await api.get('/blog');
        setPosts(res.data);
      } catch (err) {
        console.error('Error al cargar blog:', err);
      }
    };
    fetchPosts();
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-16 font-[Manrope]">
      <div className="mb-12">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Blog</h2>
        <p className="mt-2 text-lg text-gray-600">
          Conoce nuestras novedades, consejos y recursos para aprovechar al máximo HoyVemos.
        </p>
      </div>

      <div className="space-y-10">
        {posts.map((post) => (
          <Link
            to={`/blog/${post.slug}`}
            key={post.id}
            className="flex flex-col md:flex-row gap-6 items-start hover:bg-gray-50 p-4 rounded-lg transition"
          >
            {/* Imagen */}
            {post.cover_image && (
              <img
                src={`${API_URL}${post.cover_image}`}
                alt={post.title}
                className="w-full md:w-48 h-48 object-cover rounded-lg shrink-0"
              />
            )}

            {/* Contenido */}
            <div className="flex-1">
              <div className="flex items-center gap-3 text-sm text-gray-500 mb-2">
                <span>{new Date(post.published_at).toLocaleDateString()}</span>
                {post.categories && (
                  <span className="px-2 py-0.5 rounded-full text-xs bg-gray-200 text-gray-700">
                    {post.categories.split(',')[0]}
                  </span>
                )}
              </div>
              <h3 className="text-xl font-semibold text-gray-900">{post.title}</h3>
              <p className="mt-1 text-gray-600 text-sm line-clamp-3">
                {/* Puedes usar un resumen si lo agregas luego al backend */}
                {post.content_html?.replace(/<[^>]+>/g, '').slice(0, 160)}...
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
